import { render, staticRenderFns } from "./LeadershipPartial.htm?vue&type=template&id=28edafbe&scoped=true&external"
import script from "./LeadershipPartial.js?vue&type=script&lang=js&external"
export * from "./LeadershipPartial.js?vue&type=script&lang=js&external"
import style0 from "./LeadershipPartial.scss?vue&type=style&index=0&id=28edafbe&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28edafbe",
  null
  
)

export default component.exports